function isAllyHiddenRoute(): boolean {
  const mainRoute = window.location.hash.split("/")[1];
  return mainRoute === "audits" || mainRoute === "medical-records";
}

export { isAllyHiddenRoute };
